
export const common = {
  // Navigation
  nav_shop: 'მაღაზია',
  nav_loadouts: 'პაკეტი',
  nav_byd: 'BYD',
  nav_ai_assist: 'AI ასისტენტი',
  nav_wish: 'სურვილი',
  nav_menu: 'მენიუ',
  nav_search_title: 'ძიება (⌘K)',
  nav_cart_title: 'შენი პაკეტი',
  
  // Hero Section
  hero_season: 'სეზონი 2026 • ახალი პროდუქტები',
  hero_title_1: 'შექმენი შენი',
  hero_title_2: 'იდეალური სეთაპი',
  hero_description: 'გამოსცადე ელექტრონიკის შოპინგი თამაშის ფორმატში. აირჩიე შენი სურვილი, დაათვალიერე ყველა დეტალი და შეიძინე დარწმუნებით.',
  hero_cta_shop: 'მაღაზიაში შესვლა',
  hero_cta_ai: 'AI ასისტენტი',
  hero_scroll: 'გადაახვიე ქვემოთ',
  hero_background_alt: 'ჰერო ფონი',
  
  // Featured Section
  featured_label: 'გამორჩეული',
  featured_title: 'ბოლო სიახლეები',
  featured_view_all: 'ყველას ნახვა',

  // Popular Section
  popular_label: 'პოპულარული',
  popular_title: 'პოპულარული პროდუქტები',
  popular_empty: 'პოპულარული პროდუქტები ჯერ არ არის.',

  // Build Your Dream
  byd_label: 'BUILD',
  byd_title: 'შექმენი შენი ოცნება',
  byd_description: 'აირჩიე ნაწილები, შეამოწმე თავსებადობა და ააწყე პერსონალური PC.',
  byd_part_select: 'ნაწილის ტიპის არჩევა',
  byd_search_label: 'ძიება',
  byd_search_placeholder: 'ძიება სახელით ან ID-ით...',
  byd_filters_title: 'ფილტრები',
  byd_filter_brand: 'ბრენდი',
  byd_filter_price: 'ფასის დიაპაზონი',
  byd_price_min: 'მინ',
  byd_price_max: 'მაქს',
  byd_results_title: 'ხელმისაწვდომი ნაწილები',
  byd_results_empty: 'შედეგი ვერ მოიძებნა.',
  byd_selected_title: 'შენი build',
  byd_selected_count: '{{count}} ნაწილი არჩეული',
  byd_cart_label: 'Custom Build • {{count}} ნაწილი',
  byd_slot_add: 'აირჩიე ნაწილი',
  byd_slot_empty: 'ნაწილი არჩეული არაა',
  byd_remove_part: 'წაშლა',
  byd_autofill_desc: 'შეავსე დარჩენილი ნაწილები ფასის პროფილით.',
  byd_mode_label: 'რეჟიმი: {{mode}}',
  byd_mode_cheapest: 'იაფი',
  byd_mode_balanced: 'ბალანსი',
  byd_mode_random: 'შემთხვევითი',
  byd_mode_custom: 'მორგებული',
  byd_autofill_done: 'ავტოშევსება: {{mode}}',
  byd_compat_title: 'თავსებადობის შემოწმება',
  byd_compat_ok: 'არჩეული ნაწილები თავსებადია.',
  byd_compat_cpu_motherboard: 'CPU სოკეტი {{cpuSocket}} არ ემთხვევა დედაპლატის სოკეტს {{mbSocket}}.',
  byd_compat_ram_motherboard: 'RAM ტიპი {{ramType}} არ ემთხვევა დედაპლატის მეხსიერების ტიპს {{mbType}}.',
  byd_compat_case_motherboard: 'ქეისის ფორმ-ფაქტორი {{caseForm}} არ უჭერს დედაპლატის ფორმ-ფაქტორს {{mbForm}}.',
  byd_compat_cooler_cpu: 'ქულერი არ უჭერს CPU სოკეტს {{cpuSocket}}.',
  byd_compat_psu_power: 'საჭირო სიმძლავრე {{requiredWatt}}W აღემატება PSU-ს {{psuWatt}}W.',
  byd_total_label: 'Build ჯამი',
  byd_add_to_cart: 'Build-ის დამატება კალათაში',
  byd_add_disabled: 'აირჩიე მინიმუმ 3 ნაწილი',
  byd_added_to_cart: 'Build დაემატა კალათაში',
  byd_custom_name: 'BYD - Custom Build',
  byd_custom_description: 'კასტომ BYD build არჩეული ნაწილებით.',
  byd_part_preview: 'ნაწილის ნახვა',
  byd_part_view: 'პროდუქტის ნახვა',
  byd_part_cpu: 'CPU',
  byd_part_motherboard: 'დედაპლატა',
  byd_part_psu: 'კვების ბლოკი',
  byd_part_ram: 'RAM',
  byd_part_cooling: 'გაგრილების სისტემა',
  byd_part_case: 'ქეისი',
  byd_part_gpu: 'GPU',
  byd_part_storage: 'საცავი',
  byd_part_monitor: 'მონიტორი',
  byd_part_keyboard: 'კლავიატურა',
  byd_part_mouse: 'მაუსი',
  byd_part_mouse_pad: 'მაუსპადი',
  byd_part_game_controller: 'გეიმპადი',
  byd_part_speakers: 'დინამიკები',
  byd_part_headset: 'ყურსასმენი',
  byd_part_microphone: 'მიკროფონი',
  byd_part_webcam: 'ვებკამერა',
  byd_part_ups: 'UPS',
  byd_part_power_protection: 'დენის დაცვა',
  byd_part_monitor_mount: 'მონიტორის სამაგრი',
  byd_part_vr_headset: 'VR ჰედსეტი',

  // Wish Page
  wish_label: 'სურვილი',
  wish_title: 'შეაკვეთე სასურველი ტექნიკა',
  wish_description: 'მოგვწერე რას ეძებ და ჩვენ მოვძებნით შენთვის, თუნდაც მაღაზიაში არ იყოს.',
  wish_question: 'რას ისურვებდი?',
  wish_category_hint: 'აირჩიე კატეგორია მოთხოვნის დასაზუსტებლად.',
  wish_category_laptop: 'ლეპტოპი',
  wish_category_smartphone: 'სმარტფონი',
  wish_category_pc_parts: 'PC ნაწილები',
  wish_category_other: 'სხვა',
  wish_exact_model: 'ზუსტი მოდელი გაქვს?',
  wish_exact_hint: 'თუ ზუსტად იცნობ მოდელს, აირჩიე კი.',
  wish_yes: 'კი',
  wish_no: 'არა',
  wish_model_name: 'ზუსტი მოდელის დასახელება',
  wish_external_url: 'გარე ბმული (სურვილისამებრ)',
  wish_brand: 'სასურველი ბრენდი',
  wish_use_case: 'გამოყენების მიზანი',
  wish_cpu: 'სასურველი CPU / ჩიპსეტი',
  wish_ram: 'სასურველი RAM',
  wish_storage: 'სასურველი საცავი',
  wish_screen: 'ეკრანის ზომა',
  wish_color: 'სასურველი ფერი',
  wish_software: 'საჭირო პროგრამები ან აპები',
  wish_other_name: 'პროდუქტის დასახელება',
  wish_other_description: 'აღწერე რა გჭირდება',
  wish_price_min: 'ბიუჯეტი — მინ (₾)',
  wish_price_max: 'ბიუჯეტი — მაქს (₾)',
  wish_condition: 'მდგომარეობა',
  wish_contact_title: 'საკონტაქტო ინფორმაცია',
  wish_name: 'სახელი და გვარი',
  wish_phone: 'ტელეფონი',
  wish_email: 'ელ. ფოსტა',
  wish_submit: 'სურვილის გაგზავნა',
  wish_submit_loading: 'იგზავნება...',
  wish_confirm_title: 'სურვილი გაიგზავნა!',
  wish_confirm_desc: 'მივიღეთ მოთხოვნა და მალე დაგიკავშირდებით.',
  wish_submit_another: 'გაგზავნე კიდევ ერთი სურვილი',
  wish_submit_success: 'სურვილი მიღებულია',
  wish_submit_error: 'სურვილის გაგზავნა ვერ მოხერხდა',
  wish_required_contact: 'შეავსე სახელი, ტელეფონი და ელ. ფოსტა.',
  wish_required_model: 'შეიყვანე ზუსტი მოდელის დასახელება.',
  wish_required_product: 'შეიყვანე პროდუქტის დასახელება.',

  // Wish Home Section
  wish_home_label: 'სურვილი',
  wish_home_title: 'ჯინი აღარ გჭირდება.',
  wish_home_description: 'მოგვწერე ზუსტად რა გინდა და ჩვენ მოვძებნით, თუნდაც კატალოგში არ იყოს.',
  wish_home_point_1: 'ლეპტოპი, PC build ან სმარტფონი კონკრეტული სპეცებით.',
  wish_home_point_2: 'ძნელად მოსაძებნი მოდელები ან სპეციალური ვერსიები შენი ბიუჯეტით.',
  wish_home_point_3: 'ჩვენ ვპოულობთ, ვამოწმებთ და გაწვდით.',
  wish_home_cta: 'სურვილის გაგზავნა',
  wish_home_side_title: 'დაღალე ძიებით?',
  wish_home_side_description: 'იდეალური ლეპტოპი, ზუსტი PC სპეცები ან ბიუჯეტზე მორგებული ტელეფონი შეიძლება ერთ მოთხოვნაში იყოს.',
  wish_home_side_link: 'Wish ფორმის გახსნა',

  // Build Your Dream Home
  byd_home_label: 'BYD',
  byd_home_title: 'ააწყე ოცნების სისტემა ზედმეტი განსჯის გარეშე.',
  byd_home_description: 'აირჩიე ნაწილები, შეამოწმე თავსებადობა და შექმენი შენი build.',
  byd_home_cta: 'დაიწყე აწყობა',
  byd_home_side_title: 'CPU-დან პერიფერიებამდე.',
  byd_home_side_description: 'შეარჩიე ყველა კომპონენტი და Survili დაგეხმარება სრულ setup-ში.',
  byd_home_side_link: 'ბილდერის გახსნა',
  
  // Loadouts Section
  loadouts_label: 'საზოგადოება',
  loadouts_title: 'პოპულარული პაკეტი',
  loadouts_description: 'ექსპერტების მიერ შერჩეული კონფიგურაციები',
  loadouts_view: 'პაკეტის ნახვა',
  
  // AI Assistant Section
  ai_title: 'გჭირდება დახმარება?',
  ai_description: 'ჩვენი AI ასისტენტი დაგეხმარება იდეალური სეთაპის მოძიებაში შენი საჭიროებების, ბიუჯეტისა და გამოყენების მიხედვით.',
  ai_cta: 'AI ჩატის დაწყება',
  
  // Shop Page
  shop_title: 'აირჩიე შენი აღჭურვილობა',
  shop_description: 'მოირგე პარამეტრები და იპოვე სრულყოფილი სეთაპი',
  shop_tuning: 'პარამეტრები',
  shop_use_case: 'გამოყენება',
  shop_budget: 'ბიუჯეტი',
  shop_brands: 'ბრენდები',
  shop_reset: 'გასუფთავება',
  shop_products_found: 'პროდუქტი ნაპოვნია',
  shop_sort: 'დალაგება',
  shop_category: 'კატეგორია',
  shop_category_laptops: 'ლეპტოპები',
  shop_category_pc_parts: 'PC ნაწილები',
  shop_category_smartphones: 'სმარტფონები',
  shop_category_others: 'სხვა',
  shop_cpu_brand: 'CPU ბრენდი',
  shop_gpu_type: 'GPU ტიპი',
  shop_ram_gb: 'RAM (GB)',
  shop_memory_gb: 'მეხსიერება (GB)',
  shop_storage_gb: 'შენახვა (GB)',
  shop_screen_size: 'ეკრანი (ინჩი)',
  shop_refresh_rate: 'განახლება (Hz)',
  shop_part_type: 'ნაწილის ტიპი',
  shop_form_factor: 'ფორმ-ფაქტორი',
  shop_chipset: 'ჩიპსეტი / სოკეტი',
  shop_os: 'ოპერაციული სისტემა',
  shop_battery: 'ბატარეა',
  shop_camera: 'კამერა',
  shop_5g: '5G',
  shop_5g_any: 'ყველა',
  shop_5g_only: 'მხოლოდ 5G',
  shop_5g_no: '5G გარეშე',
  shop_accessory_type: 'აქსესუარის ტიპი',
  shop_compatibility: 'თავსებადობა',
  
  // Product Actions
  product_inspect: 'დათვალიერება',
  product_add: 'კალათაში დამატება',
  
  // Cart
  cart_title: 'შენი სურვილი',
  cart_empty: 'შენი სურვილი ცარიელია',
  cart_checkout: 'შეკვეთის გაფორმება',
  cart_total: 'სულ',
  
  // Footer
  footer_tagline: 'ახალი თაობის ელექტრონიკის შოპინგი თამაშის ინტერფეისით.',
  footer_shop: 'მაღაზია',
  footer_support: 'მხარდაჭერა',
  footer_connect: 'კავშირი',
  footer_copyright: '© 2023 Project Survili. ყველა უფლება დაცულია.',
  footer_powered: 'შექმნილია Survili.com-ის მიერ',
  footer_shipping: 'მიწოდება',
  footer_terms: 'წესები',
  footer_about: 'ჩვენ შესახებ',
  footer_social_missing: 'დააყენე Admin → Settings-ში',

  // Mission Bar
  mission_title: 'მისია სურვილი',
  mission_items_selected_one: '{{count}} ნივთი არჩეულია',
  mission_items_selected_other: '{{count}} ნივთი არჩეულია',
  mission_total_amount: 'ჯამური თანხა',
  mission_checkout: 'გადადი გადახდაზე',
  mission_label: 'სურვილი',

  // Pull to Refresh
  pull_refreshing: 'განახლება...',
  pull_release: 'გაუშვი განახლებისთვის',
  pull_pull: 'ქვევით ჩამოწიე განახლებისთვის',
  
  // Common
  price_currency: 'ლარი',
  loading: 'იტვირთება...',
  back: 'უკან',

  // Product Page
  product_overview: 'მიმოხილვა',
  product_specs: 'სპეციფიკაცია',
  product_compare: 'შედარება',
  product_save: 'შენახვა',
  product_share: 'გაზიარება',
  product_similar: 'მსგავსი პროდუქტები',
  product_add_to_survili: 'სურვილში დამატება',
  product_back_shop: 'მაღაზიაში დაბრუნება',
  product_quantity: 'რაოდენობა',
  product_performance: 'შესრულების მაჩვენებლები',
  product_tech_specs: 'ტექნიკური სპეციფიკაცია',
  product_ai_compare: 'AI შედარება',
  product_ai_compare_desc: 'გამოიყენე ჩვენი AI ასისტენტი ამ პროდუქტის ალტერნატივებთან შესადარებლად და პერსონალური რეკომენდაციების მისაღებად.',
  product_start_comparison: 'AI შედარების დაწყება',
  product_coming_soon: 'მალე!',
  condition_new: 'ახალი',
  condition_used: 'მეორადი',

  // Loadouts Page
  loadouts_page_title: 'პაკეტები',
  loadouts_page_desc: 'ექსპერტების მიერ შერჩეული პროდუქტების ნაკრებები',
  loadouts_items: 'ნივთი',
  loadouts_total: 'სულ',
  loadouts_view_details: 'დეტალების ნახვა',

  // Checkout
  checkout_title: 'შეკვეთის დადასტურება',
  checkout_subtitle: 'დაასრულე შენი სურვილის შეძენა',
  checkout_identity: 'იდენტიფიკაცია',
  checkout_delivery: 'მიწოდება',
  checkout_payment: 'გადახდის მეთოდი',
  checkout_order_summary: 'შეკვეთის შეჯამება',
  checkout_confirm: 'დადასტურება',
  checkout_continue: 'გაგრძელება',
  checkout_wire: 'გადარიცხვა',
  checkout_card: 'ბარათი',
  checkout_installment: 'განვადება',

  // Reviews
  reviews_title: 'მომხმარებლების შეფასებები',
  reviews_write: 'შეფასების დაწერა',
  reviews_submit: 'გაგზავნა',
  reviews_name: 'შენი სახელი',
  reviews_rating: 'შეფასება',
  reviews_comment: 'შენი კომენტარი',
  reviews_no_reviews: 'შეფასებები ჯერ არ არის. იყავი პირველი!',

  // Sort Options
  sort_newest: 'ახალი პირველი',
  sort_price_low: 'ფასი: დაბლიდან მაღლა',
  sort_price_high: 'ფასი: მაღლიდან დაბლა',
  sort_name_asc: 'სახელი: ა-დან ჰ-მდე',
  sort_name_desc: 'სახელი: ჰ-დან ა-მდე',

  // Not Found
  notfound_title: 'მისია ჩავარდა',
  notfound_subtitle: 'სამიზნე მდებარეობა ვერ მოიძებნა',
  notfound_return_home: 'ბაზაზე დაბრუნება',
  notfound_browse_shop: 'მაღაზიის ნახვა',

  // Toasts
  toast_added_to_cart: 'დაემატა {{name}} შენს სურვილში!',
  toast_added_to_cart_qty: 'დაემატა {{count}}x {{name}} შენს სურვილში!',
  toast_save_coming: 'შენახვის ფუნქცია მალე დაემატება!',
  toast_link_copied: 'ბმული დაკოპირდა!',
  toast_review_missing: 'გთხოვ შეავსო სახელი და კომენტარი',
  toast_review_success: 'შეფასება წარმატებით გაიგზავნა!',
  toast_review_error: 'შეფასების გაგზავნა ვერ მოხერხდა. სცადე თავიდან.',
  toast_iban_copied: 'IBAN დაკოპირდა!',
  toast_redirecting_payment: 'გადამისამართება გადახდის გვერდზე...',
  toast_payment_unavailable: 'გადახდის სერვისი მიუწვდომელია. სცადე საბანკო გადარიცხვა.',
  toast_order_failed: 'შეკვეთის შექმნა ვერ მოხერხდა. სცადე თავიდან.',

  // Shop Extras
  shop_badge: 'SURVILI SELECT',
  shop_usecase_gaming: 'გეიმინგი',
  shop_usecase_office: 'ოფისი',
  shop_usecase_editing: 'რედაქტირება',
  shop_usecase_student: 'სტუდენტი',

  // Stat Labels
  stat_short_performance: 'წარმ',
  stat_short_battery: 'ბატ',
  stat_short_display: 'ეკრ',
  stat_short_portability: 'პორტ',
  stat_short_upgradeability: 'განა',
  stat_label_performance: 'წარმადობა',
  stat_label_battery: 'ბატარეა',
  stat_label_display: 'ეკრანი',
  stat_label_portability: 'პორტაბელურობა',
  stat_label_upgradeability: 'განახლებადობა',

  // Specs
  spec_cpu: 'CPU',
  spec_gpu: 'GPU',
  spec_ram: 'RAM',
  spec_storage: 'მეხსიერება',
  spec_display: 'ეკრანი',
  spec_cpu_brand: 'CPU ბრენდი',
  spec_gpu_type: 'GPU ტიპი',
  spec_ram_gb: 'RAM (GB)',
  spec_storage_gb: 'მეხსიერება (GB)',
  spec_screen_size_in: 'ეკრანი (ინჩი)',
  spec_refresh_hz: 'განახლება (Hz)',
  spec_pc_part_type: 'ნაწილის ტიპი',
  spec_form_factor: 'ფორმ-ფაქტორი',
  spec_chipset: 'ჩიპსეტი / სოკეტი',
  spec_os: 'ოპერაციული სისტემა',
  spec_battery_mah: 'ბატარეა (mAh)',
  spec_camera_mp: 'კამერა (MP)',
  spec_supports_5g: '5G მხარდაჭერა',
  spec_accessory_type: 'აქსესუარის ტიპი',
  spec_compatibility: 'თავსებადობა',
  spec_cpu_manufacturer: 'CPU მწარმოებელი',
  spec_cpu_model_name: 'CPU მოდელი',
  spec_cpu_series: 'CPU სერია',
  spec_cpu_socket: 'CPU სოკეტი',
  spec_cpu_generation: 'CPU თაობა',
  spec_cpu_cores: 'CPU ბირთვები',
  spec_cpu_threads: 'CPU ნაკადები',
  spec_cpu_base_clock_ghz: 'საბაზო სიჩქარე (GHz)',
  spec_cpu_boost_clock_ghz: 'ბუსტი (GHz)',
  spec_cpu_tdp_watt: 'TDP (W)',
  spec_cpu_integrated_graphics: 'ინტეგრირებული გრაფიკა',
  spec_cpu_cooler_included: 'ქულერი კომპლექტში',
  spec_motherboard_manufacturer: 'Motherboard მწარმოებელი',
  spec_motherboard_model_name: 'Motherboard მოდელი',
  spec_motherboard_socket: 'Motherboard სოკეტი',
  spec_motherboard_chipset: 'Motherboard ჩიპსეტი',
  spec_motherboard_form_factor: 'Motherboard ფორმ-ფაქტორი',
  spec_motherboard_memory_type: 'მეხსიერების ტიპი',
  spec_motherboard_memory_slots: 'სლოტების რაოდენობა',
  spec_motherboard_max_memory_gb: 'მაქს. მეხსიერება (GB)',
  spec_motherboard_pcie_version: 'PCIe ვერსია',
  spec_motherboard_m2_slots: 'M.2 სლოტები',
  spec_motherboard_sata_ports: 'SATA პორტები',
  spec_motherboard_ethernet_speed: 'Ethernet სიჩქარე',
  spec_motherboard_wifi: 'Wi‑Fi',
  spec_motherboard_bluetooth: 'Bluetooth',
  spec_motherboard_bios_flashback: 'BIOS Flashback',
  spec_psu_manufacturer: 'PSU მწარმოებელი',
  spec_psu_model_name: 'PSU მოდელი',
  spec_psu_wattage: 'PSU სიმძლავრე',
  spec_psu_efficiency_rating: 'ეფექტიანობის რეიტინგი',
  spec_psu_modularity: 'მოდულარობა',
  spec_psu_form_factor: 'PSU ფორმ-ფაქტორი',
  spec_psu_fan_size_mm: 'ვენტილატორი (მმ)',
  spec_psu_protections: 'დაცვა',
  spec_ram_manufacturer: 'RAM მწარმოებელი',
  spec_ram_model_name: 'RAM მოდელი',
  spec_ram_memory_type: 'RAM ტიპი',
  spec_ram_capacity_gb: 'RAM მოცულობა (GB)',
  spec_ram_kit_configuration: 'RAM კიტი',
  spec_ram_speed_mhz: 'RAM სიჩქარე (MHz)',
  spec_ram_latency_cl: 'RAM ლატენტობა (CL)',
  spec_ram_voltage_v: 'RAM ვოლტაჟი (V)',
  spec_ram_rgb: 'RAM RGB',
  spec_cooler_type: 'ქულერის ტიპი',
  spec_cooler_supported_sockets: 'დახმარებული სოკეტები',
  spec_cooler_radiator_size_mm: 'რადიატორი (მმ)',
  spec_cooler_fan_count: 'ვენტილატორების რაოდენობა',
  spec_cooler_noise_level_db: 'ხმაური (დბ)',
  spec_cooler_rgb: 'ქულერის RGB',
  spec_case_manufacturer: 'ქეისის მწარმოებელი',
  spec_case_model_name: 'ქეისის მოდელი',
  spec_case_type: 'ქეისის ტიპი',
  spec_case_supported_form_factors: 'დახმარებული ფორმ-ფაქტორები',
  spec_case_material: 'მასალა',
  spec_case_included_fans: 'ჩაშენებული ვენტილატორები',
  spec_case_rgb: 'ქეისის RGB',
  spec_case_color: 'ქეისის ფერი',
  spec_gpu_manufacturer: 'GPU მწარმოებელი',
  spec_gpu_brand_partner: 'ბრენდ პარტნიორი',
  spec_gpu_model_name: 'GPU მოდელი',
  spec_gpu_chipset: 'GPU ჩიპსეტი',
  spec_gpu_vram_gb: 'VRAM (GB)',
  spec_gpu_memory_type: 'GPU მეხსიერების ტიპი',
  spec_gpu_pcie_version: 'GPU PCIe ვერსია',
  spec_gpu_power_connector: 'დენის კონექტორი',
  spec_gpu_power_watt: 'GPU სიმძლავრე (W)',
  spec_storage_type: 'მეხსიერების ტიპი',
  spec_storage_capacity_gb: 'მეხსიერების მოცულობა (GB)',
  spec_storage_form_factor: 'ფორმ-ფაქტორი',
  spec_storage_interface: 'ინტერფეისი',
  spec_storage_read_speed_mb_s: 'წაკითხვა (MB/s)',
  spec_storage_write_speed_mb_s: 'ჩაწერა (MB/s)',
  spec_monitor_screen_size_inch: 'ეკრანის ზომა (ინჩი)',
  spec_monitor_resolution: 'რეზოლუცია',
  spec_monitor_panel_type: 'პანელის ტიპი',
  spec_monitor_refresh_rate_hz: 'განახლება (Hz)',
  spec_monitor_response_time_ms: 'რეაგირება (ms)',
  spec_monitor_ports: 'პორტები',
  spec_monitor_vesa_mount: 'VESA დამაგრება',
  spec_keyboard_type: 'კლავიატურის ტიპი',
  spec_keyboard_layout: 'ლაიაუთი',
  spec_keyboard_switch_type: 'სვიჩის ტიპი',
  spec_keyboard_connection: 'კავშირი',
  spec_keyboard_rgb: 'კლავიატურის RGB',
  spec_keyboard_language_layout: 'ენის ლაიაუთი',
  spec_mouse_sensor_type: 'სენსორის ტიპი',
  spec_mouse_dpi_max: 'DPI მაქს',
  spec_mouse_buttons: 'ღილაკები',
  spec_mouse_connection: 'კავშირი',
  spec_mouse_rgb: 'მაუსის RGB',
  spec_mousepad_size: 'მაუსპადის ზომა',
  spec_mousepad_surface_type: 'ზედაპირის ტიპი',
  spec_mousepad_rgb: 'მაუსპადის RGB',
  spec_controller_type: 'კონტროლერის ტიპი',
  spec_controller_platform_support: 'პლატფორმის მხარდაჭერა',
  spec_controller_connection: 'კავშირი',
  spec_speakers_channel_configuration: 'არხები',
  spec_speakers_power_watt: 'სიმძლავრე (W)',
  spec_speakers_connection: 'კავშირი',
  spec_headset_type: 'ყურსასმენის ტიპი',
  spec_headset_connection: 'კავშირი',
  spec_headset_microphone: 'მიკროფონი',
  spec_headset_surround_sound: 'Surround Sound',
  spec_microphone_type: 'მიკროფონის ტიპი',
  spec_microphone_pickup_pattern: 'მიმღები ტიპი',
  spec_microphone_frequency_response_hz: 'სიხშირის დიაპაზონი',
  spec_webcam_resolution: 'ვებკამერის რეზოლუცია',
  spec_webcam_frame_rate_fps: 'კადრი (FPS)',
  spec_webcam_autofocus: 'ავტოფოკუსი',
  spec_webcam_microphone: 'მიკროფონი',
  spec_ups_capacity_va: 'სიმძლავრე (VA)',
  spec_ups_output_watt: 'გამავალი (W)',
  spec_ups_type: 'UPS ტიპი',
  spec_ups_outlets: 'სოკეტები',
  spec_power_protection_type: 'დაცვის ტიპი',
  spec_power_protection_outlets: 'სოკეტები',
  spec_power_protection_max_load_watt: 'მაქს. დატვირთვა (W)',
  spec_monitor_mount_type: 'დამაგრების ტიპი',
  spec_monitor_mount_vesa_support: 'VESA მხარდაჭერა',
  spec_monitor_mount_max_screen_size_inch: 'მაქს. ეკრანი (ინჩი)',
  spec_monitor_mount_adjustment: 'რეგულირება',
  spec_vr_platform_support: 'VR პლატფორმა',
  spec_vr_resolution_per_eye: 'რეზოლუცია თითო თვალზე',
  spec_vr_refresh_rate_hz: 'VR განახლება (Hz)',
  spec_vr_tracking_type: 'თრექინგის ტიპი',
  spec_vr_connection: 'VR კავშირი',
  product_specs_empty: 'ამ პროდუქტისთვის სპეციფიკაციები არ არის ხელმისაწვდომი.',
  product_not_found_title: 'პროდუქტი ვერ მოიძებნა',
  product_not_found_back: 'მაღაზიაში დაბრუნება',
  breadcrumb_home: 'მთავარი',
  breadcrumb_shop: 'მაღაზია',

  // Loadouts
  loadouts_empty_title: 'პაკეტი ჯერ არ არის',
  loadouts_empty_desc: 'მალე დაემატება შერჩეული სეთაპები',
  loadouts_browse_shop: 'მაღაზიის ნახვა',
  loadout_not_found_title: 'პაკეტი ვერ მოიძებნა.',
  loadout_not_found_back: 'მთავარზე დაბრუნება',
  loadout_add_all: 'ყველას დამატება კალათაში და გადახდა',
  loadout_products_title: 'პროდუქტები ამ პაკეტში',
  loadout_products_empty: 'ამ პაკეტში პროდუქტები ვერ მოიძებნა.',

  // Search
  search_placeholder: 'მოძებნე პროდუქტები, კატეგორიები, ბრენდები...',
  search_hint_close: 'დასახურად',
  search_hint_search: 'ძიებისთვის',
  search_loading: 'ძებნა...',
  search_results_one: '{{count}} შედეგი მოიძებნა',
  search_results_other: '{{count}} შედეგი მოიძებნა',
  search_no_results_title: 'შედეგი ვერ მოიძებნა',
  search_no_results_message: 'სცადე სხვა საკვანძო სიტყვები ან გადადი ჩვენს',
  search_no_results_shop: 'მაღაზიაში',
  search_recent: 'ბოლო ძიებები',
  search_clear: 'გასუფთავება',
  search_start_title: 'დაიწყე ძიება',
  search_start_desc: 'იპოვე პროდუქტები სახელით, კატეგორიით ან ბრენდით',
  search_quick_links: 'სწრაფი ბმულები',
  search_quick_all_products: 'ყველა პროდუქტი',
  search_quick_loadouts: 'პაკეტი',
  search_quick_gaming: 'გეიმინგი',
  search_quick_laptops: 'ლეპტოპები',

  // Reviews
  reviews_summary_one: '{{rating}} / 5 ({{count}} შეფასება)',
  reviews_summary_other: '{{rating}} / 5 ({{count}} შეფასება)',
  reviews_write_title: 'შეფასების დაწერა',
  reviews_name_required: 'შენი სახელი *',
  reviews_rating_label: 'შეფასება *',
  reviews_title_optional: 'შეფასების სათაური (არასავალდებულო)',
  reviews_title_placeholder: 'შეჯამება',
  reviews_name_placeholder: 'შეიყვანე შენი სახელი',
  reviews_comment_label: 'შენი შეფასება *',
  reviews_comment_placeholder: 'გაგვიზიარე გამოცდილება ამ პროდუქტზე...',
  reviews_cancel: 'გაუქმება',
  reviews_verified: 'დამოწმებული',

  // Checkout Extras
  checkout_empty_desc: 'დაამატე პროდუქტები გასაგრძელებლად',
  checkout_complete_title: 'მისია დასრულდა!',
  checkout_complete_desc: 'შეკვეთა დადასტურდა',
  checkout_order_id_label: 'შეკვეთის ID',
  checkout_back: 'უკან',
  checkout_processing: 'მუშავდება...',
  checkout_full_name: 'სრული სახელი',
  checkout_email: 'ელ. ფოსტა',
  checkout_phone: 'ტელეფონი',
  checkout_address: 'მისამართი',
  checkout_city: 'ქალაქი',
  checkout_payment_card_title: 'BOG ბარათით გადახდა',
  checkout_payment_card_desc: 'თქვენ გადაიამისამართებით BOG გადახდის გვერდზე უსაფრთხო გადახდისთვის.',
  checkout_payment_card_soon_title: 'ბარათით გადახდა მალე',
  checkout_payment_card_soon_desc: 'ბარათით გადახდა მზადდება. ამ ეტაპზე გამოიყენე საბანკო გადარიცხვა.',
  checkout_installment_bog_desc: 'თქვენ გადაიამისამართებით BOG-ზე განვადების დასასრულებლად.',
  checkout_installment_pending_desc: 'არჩეული განვადება დამუშავდება შეკვეთის დადასტურების შემდეგ.',
  checkout_installment_change: 'არჩევანის შეცვლა',
  checkout_installment_confirm: 'გაგრძელება BOG-თან',
  checkout_installment_title: 'BOG განვადება',
  checkout_installment_rate_title: 'განვადება ეფექტური 26%-დან',
  checkout_installment_rate_body1: 'გადახდა შენზე მორგებული გრაფიკით',
  checkout_installment_rate_body2: 'მარტივი პირობები',
  checkout_installment_months_label: 'აირჩიე ვადა (თვე)',
  checkout_bnpl_title: 'BOG ნაწილ-ნაწილ',
  checkout_bnpl_desc: '4 თანაბარ ნაწილად · პირველი გადახდა 1 თვეში · დამალული საკომისიოების გარეშე',
  checkout_bnpl_short: 'ნაწილ-ნაწილ',
  checkout_installment_short: 'განვადება',
  checkout_bnpl_payment_1: '1-ლი გადახდა',
  checkout_bnpl_payment_2: 'მე-2 გადახდა',
  checkout_bnpl_payment_3: 'მე-3 გადახდა',
  checkout_bnpl_payment_4: 'მე-4 გადახდა',
  checkout_order_summary_title: 'შეკვეთის შეჯამება',
  checkout_total_label: 'სულ',
  checkout_installment_select_title: 'აირჩიე განვადების გეგმა',
  checkout_installment_coming_soon: 'მალე',

  // Payment Success
  payment_success_title: 'მისია დასრულდა!',
  payment_success_message: 'გადახდა წარმატებულია. შეკვეთა დამუშავდება.',
  payment_success_order_id: 'შეკვეთის ID',
  payment_success_amount_paid: 'გადახდილი თანხა',
  payment_success_next_title: 'რა ხდება შემდეგ?',
  payment_success_next_1: 'SMS-ით მიიღებ შეკვეთის დადასტურებას',
  payment_success_next_2: 'ჩვენი გუნდი მოამზადებს ნივთებს გაგზავნისთვის',
  payment_success_next_3: 'გაცნობებთ, როცა შეკვეთა გაიგზავნება',
  payment_success_continue: 'გაგრძელე შოპინგი',
  payment_success_go_home: 'მთავარზე დაბრუნება',

  // Payment Fail
  payment_fail_title: 'მისია ჩავარდა',
  payment_fail_message: 'გადახდა ვერ დასრულდა. სცადე კიდევ ერთხელ.',
  payment_fail_panel_title: 'გადახდა წარუმატებელია',
  payment_fail_panel_desc: 'გადახდა გაუქმდა ან უარყოფილია. შეკვეთა არ დამუშავებულა და თანხა არ ჩამოგეჭრებათ.',
  payment_fail_order_ref: 'შეკვეთის რეფერენსი',
  payment_fail_help_title: 'რა შეგიძლია გააკეთო?',
  payment_fail_help_1: 'სცადე სხვა გადახდის მეთოდით',
  payment_fail_help_2: 'შეამოწმე ბარათის მონაცემები და ბალანსი',
  payment_fail_help_3: 'საკითხის გაგრძელებისას დაუკავშირდი ბანკს',
  payment_fail_try_again: 'კიდევ სცადე',
  payment_fail_get_help: 'დახმარება',
  payment_fail_back_shop: 'მაღაზიაში დაბრუნება',

  // AI Assistant
  ai_assistant_title: 'AI ასისტენტი – მალე',
  ai_assistant_desc: 'ვმუშაობთ თამაშის სტილის AI თანამგზავრზე, რომელიც დაგეხმარება იდეალური სეთაპის არჩევაში.',
  ai_assistant_back: 'მთავარზე დაბრუნება',

  // Shipping Policy
  shipping_seo_title: 'მიწოდების პოლიტიკა | Project Survili',
  shipping_seo_desc: 'გაიგე მიწოდების ვარიანტები, ვადები და ღირებულება ელექტრონიკის შეკვეთებისთვის საქართველოში.',
  shipping_badge: 'მიწოდების ინფორმაცია',
  shipping_title: 'მიწოდების პოლიტიკა',
  shipping_subtitle: 'სწრაფი და უსაფრთხო მიწოდება საქართველოში',
  shipping_zones_title: 'მიწოდების ზონები',
  shipping_zone_tbilisi_title: 'თბილისი',
  shipping_zone_tbilisi_desc: '₾200-ზე მეტი შეკვეთისთვის უფასო მიწოდება. სტანდარტული მიწოდება: ₾10',
  shipping_zone_cities_title: 'ბათუმი, ქუთაისი, რუსთავი',
  shipping_zone_cities_desc: 'სტანდარტული მიწოდება: ₾15-20 მდებარეობის მიხედვით',
  shipping_zone_other_title: 'სხვა რეგიონები',
  shipping_zone_other_desc: 'მიწოდება კურიერის სერვისით. ღირებულება ითვლება გადახდაზე.',
  shipping_times_title: 'მიწოდების დროები',
  shipping_express_label: 'ექსპრესი',
  shipping_express_time: 'დღის განმავლობაში',
  shipping_express_desc: 'შეკვეთები 14:00-მდე (მხოლოდ თბილისი)',
  shipping_standard_label: 'სტანდარტული მიწოდება',
  shipping_standard_time: '1-3 დღე',
  shipping_standard_desc: 'მთელ საქართველოში',
  shipping_tracking_title: 'შეკვეთის თვალყურის დევნება',
  shipping_tracking_desc: 'შეკვეთის გაგზავნის შემდეგ მიიღებ SMS-ს და ელფოსტის შეტყობინებას ტრეკინგის დეტალებით. სტატუსის სანახავად დაგვიკავშირდი მხარდაჭერას.',
  shipping_whatsapp_support: 'WhatsApp მხარდაჭერა',
  shipping_important_title: 'მნიშვნელოვანი შენიშვნები',
  shipping_note_1: 'დარწმუნდი, რომ ვინმე იქნება მისამართზე ამანათის მისაღებად.',
  shipping_note_2: 'მიწოდების დრო შესაძლოა შეიცვალოს დღესასწაულებსა და პიკის სეზონზე.',
  shipping_note_3: 'ყველა პროდუქტი უსაფრთხოდ არის შეფუთული.',
  shipping_note_4: 'მიიღე და შეამოწმე ამანათი, დაზიანების შემთხვევაში მოგვწერე დაუყოვნებლივ.',

  // About Us
  about_seo_title: 'ჩვენ შესახებ | Project Survili',
  about_seo_desc: 'გაიცანი Project Survili - საქართველოს სათამაშო სტილის ელექტრონიკის მაღაზია. გაიგე ჩვენი მისია, გუნდი და საგარანტიო პოლიტიკა.',
  about_badge: 'ვინ ვართ',
  about_title: 'ჩვენ შესახებ',
  about_subtitle: 'ელექტრონიკის შოპინგის ახალი სტანდარტი საქართველოში',
  about_nav_about: 'ჩვენ შესახებ',
  about_nav_warranty: 'გარანტია',
  about_mission_title: 'ჩვენი მისია',
  about_mission_body: 'Project Survili ცვლის ელექტრონიკის შოპინგის გამოცდილებას. ჩვენ გადავაქციეთ ონლაინ შოპინგი თამაშად, სადაც თითოეული პროდუქტი არის "სურვილი" (loadout), რომელიც მზადაა შენი დღის მისიებისთვის.',
  about_stat_products: 'პროდუქტი',
  about_stat_customers: 'კმაყოფილი მომხმარებელი',
  about_stat_support: 'მხარდაჭერა',
  about_values_title: 'ჩვენი ღირებულებები',
  about_value_quality_title: 'ხარისხი პირველ რიგში',
  about_value_quality_desc: 'ვყიდით მხოლოდ იმ პროდუქტებს, რომლებშიც გვჯერა. ყველა პროდუქტი მოწმდება ხარისხზე.',
  about_value_pricing_title: 'სამართლიანი ფასები',
  about_value_pricing_desc: 'კონკურენტული ფასები ხარისხისა და სერვისის კომპრომისის გარეშე.',
  about_value_customer_title: 'მომხმარებელი პირველ ადგილზე',
  about_value_customer_desc: 'შენი კმაყოფილება ჩვენი პრიორიტეტია. მზად ვართ 24/7 დაგეხმაროთ.',
  about_value_innovation_title: 'ინოვაცია',
  about_value_innovation_desc: 'ვაუმჯობესებთ პლატფორმას უკეთესი გამოცდილებისთვის.',
  about_contact_title: 'დაგვიკავშირდი',
  about_contact_whatsapp: 'WhatsApp',
  about_contact_phone: 'ტელეფონი',
  about_contact_email: 'ელ. ფოსტა',
  about_contact_instagram: 'Instagram',
  about_warranty_title: 'საგარანტიო პოლიტიკა',
  about_warranty_overview: 'ჩვენ ვდგავართ ყველა გაყიდული პროდუქტის უკან. ყველა ნივთს აქვს მწარმოებლის გარანტია და დამატებით მხარდაჭერას ვთავაზობთ სრულ კმაყოფილებასთვის.',
  about_warranty_standard_title: 'სტანდარტული გარანტია',
  about_warranty_standard_desc: '12 თვიანი მწარმოებლის გარანტია ყველა პროდუქტზე',
  about_warranty_extended_title: 'გაფართოებული ვარიანტები',
  about_warranty_extended_desc: 'შერჩეულ პროდუქტებზე შესაძლებელია გაფართოებული გარანტია',
  about_warranty_covered_title: 'რა ვრცელდება',
  about_warranty_covered_label: 'ვრცელდება',
  about_warranty_not_covered_label: 'არ ვრცელდება',
  about_warranty_covered_1: 'მწარმოებლური დეფექტები',
  about_warranty_covered_2: 'ჰარდვერის გაუმართაობა',
  about_warranty_covered_3: 'გარდამწვარი პიქსელები (პოლიტიკის ფარგლებში)',
  about_warranty_covered_4: 'ბატარეის დეფექტები',
  about_warranty_not_covered_1: 'ფიზიკური დაზიანება',
  about_warranty_not_covered_2: 'წყლის დაზიანება',
  about_warranty_not_covered_3: 'უნებართვო მოდიფიკაციები',
  about_warranty_not_covered_4: 'ბუნებრივი ცვეთა',
  about_warranty_claim_title: 'როგორ გავაკეთოთ საგარანტიო მოთხოვნა',
  about_warranty_step1_title: 'დაგვიკავშირდი',
  about_warranty_step1_desc: 'WhatsApp-ზე ან ტელეფონით მოგვწერე შეკვეთის დეტალები და პრობლემა.',
  about_warranty_step2_title: 'დიაგნოსტიკა',
  about_warranty_step2_desc: 'ჩვენი გუნდი შეაფასებს პრობლემას და დაადგენს საგარანტიო პირობებს.',
  about_warranty_step3_title: 'გადაწყვეტა',
  about_warranty_step3_desc: 'შეკეთება, ჩანაცვლება ან დაბრუნება მოხდება ჩვენი პოლიტიკის მიხედვით.',
  about_return_title: '14-დღიანი დაბრუნების პოლიტიკა',
  about_return_desc: 'გადაიფიქრე? გაუხსნელ პროდუქტს 14 დღის განმავლობაში შეუძლია დაბრუნება სრული ანაზღაურებისთვის. პროდუქტი უნდა იყოს ორიგინალ შეფუთვაში ყველა აქსესუარით.',
  about_return_bullet1: 'პროდუქტი უნდა იყოს გამოუყენებელი და ორიგინალ მდგომარეობაში',
  about_return_bullet2: 'აუცილებელია ქვითარი ან შეძენის დამადასტურებელი დოკუმენტი',
  about_return_bullet3: 'დაბრუნების მიწოდების ხარჯი შესაძლოა იყოს გადასახდელი',
  about_last_updated: 'ბოლო განახლება: დეკემბერი 2023',

  // Terms & Privacy
  terms_seo_title: 'წესები და კონფიდენციალურობა | Project Survili',
  terms_seo_desc: 'წაიკითხე მომსახურების წესები და კონფიდენციალურობის პოლიტიკა. გაიგე როგორ ვმართავთ მონაცემებს და რა წესებია Project Survili-ში.',
  terms_badge: 'იურიდიული ინფორმაცია',
  terms_title: 'წესები და კონფიდენციალურობა',
  terms_subtitle: 'შენი უფლებები და ჩვენი ვალდებულებები',
  terms_nav_terms: 'მომსახურების წესები',
  terms_nav_privacy: 'კონფიდენციალურობის პოლიტიკა',
  terms_section_title: 'მომსახურების წესები',
  terms_accept_title: '1. წესების მიღება',
  terms_accept_body: 'Project Survili-ს გამოყენებით, თქვენ ეთანხმებით ამ წესებს. თუ არ ეთანხმებით, გთხოვთ, არ გამოიყენოთ ჩვენი სერვისები.',
  terms_products_title: '2. პროდუქტები და შეკვეთები',
  terms_products_bullet1: 'ყველა პროდუქტი ხელმისაწვდომობაზეა დამოკიდებული.',
  terms_products_bullet2: 'ფასები მითითებულია ლარებში (GEL) და შეიძლება შეიცვალოს წინასწარი შეტყობინების გარეშე.',
  terms_products_bullet3: 'ვიტოვებთ უფლებას უარი ვთქვათ ან გავაუქმოთ შეკვეთა.',
  terms_products_bullet4: 'შეკვეთის დადასტურება არ ნიშნავს ხელმისაწვდომობას გაგზავნამდე.',
  terms_payment_title: '3. გადახდა',
  terms_payment_body: 'გადახდა ხდება შეკვეთის გაკეთებისას. ჩვენ ვიღებთ სხვადასხვა გადახდის მეთოდს, მათ შორის ბარათით გადახდას და ადგილზე გადახდას ხელმისაწვდომობის შემთხვევაში. ყველა ტრანზაქცია დამუშავდება უსაფრთხოდ.',
  terms_conduct_title: '4. მომხმარებლის ქცევა',
  terms_conduct_intro: 'თქვენ ვალდებულდებით არ:',
  terms_conduct_bullet1: 'გამოიყენოთ სერვისი უკანონო მიზნებისთვის.',
  terms_conduct_bullet2: 'ჩარიოთ საიტის გამართულ მუშაობაში.',
  terms_conduct_bullet3: 'გაწვდოთ ცრუ ან შეცდომაში შემყვანი ინფორმაცია.',
  terms_liability_title: '5. პასუხისმგებლობის შეზღუდვა',
  terms_liability_body: 'Project Survili არ აგებს პასუხს არაპირდაპირ, შემთხვევით, სპეციალურ ან შედეგობრივ ზიანზე, რომელიც წარმოშობილია სერვისის გამოყენებით. ჩვენი საერთო პასუხისმგებლობა არ გადააჭარბებს პროდუქტში გადახდილ თანხას.',
  privacy_section_title: 'კონფიდენციალურობის პოლიტიკა',
  privacy_collect_title: 'რა მონაცემებს ვაგროვებთ',
  privacy_collect_body: 'შეკვეთების დასამუშავებლად ვაგროვებთ შემდეგ მონაცემებს:',
  privacy_collect_fullname: 'სრული სახელი',
  privacy_collect_phone: 'ტელეფონის ნომერი',
  privacy_collect_email: 'ელ. ფოსტა',
  privacy_collect_address: 'მიწოდების მისამართი',
  privacy_use_title: 'როგორ ვიყენებთ თქვენს მონაცემებს',
  privacy_use_bullet1: 'შეკვეთების დამუშავება და მიწოდება.',
  privacy_use_bullet2: 'შეკვეთის სტატუსზე კომუნიკაცია.',
  privacy_use_bullet3: 'მომხმარებლის მხარდაჭერის უზრუნველყოფა.',
  privacy_use_bullet4: 'სერვისებისა და გამოცდილების გაუმჯობესება.',
  privacy_data_title: 'მონაცემთა დაცვა',
  privacy_data_card_title: 'თქვენი მონაცემები დაცულია',
  privacy_data_card_body: 'ვიყენებთ ინდუსტრიის სტანდარტის უსაფრთხოების ზომებს თქვენი პერსონალური მონაცემების დასაცავად. არ ვყიდით და არ ვუზიარებთ მონაცემებს მესამე პირებს, გარდა შეკვეთის შესრულებისთვის აუცილებელი შემთხვევებისა.',
  privacy_cookies_title: 'ქუქიები',
  privacy_cookies_body: 'ვიყენებთ ქუქიებს გამოცდილების გასაუმჯობესებლად, მათ შორის კალათისა და ენის არჩევანის დამახსოვრებისთვის. შეგიძლიათ გამორთოთ ქუქიები ბრაუზერის პარამეტრებიდან, თუმცა შესაძლოა გავლენა ჰქონდეს ფუნქციონალზე.',
  privacy_rights_title: 'თქვენი უფლებები',
  privacy_rights_intro: 'თქვენ გაქვთ უფლება:',
  privacy_rights_bullet1: 'მოითხოვოთ თქვენი პერსონალური მონაცემების ნახვა.',
  privacy_rights_bullet2: 'მოითხოვოთ არასწორი მონაცემების შესწორება.',
  privacy_rights_bullet3: 'მოითხოვოთ მონაცემების წაშლა (როდესაც ეს შესაძლებელია).',
  privacy_questions_title: 'კითხვები?',
  privacy_questions_body: 'თუ გაქვთ კითხვები მომსახურების წესებზე ან კონფიდენციალურობის პოლიტიკაზე, დაგვიკავშირდით:',
  terms_last_updated: 'ბოლო განახლება: დეკემბერი 2023',
};

export default common;
